<template>
  <main role="main">
    <b-container class="py-5">
      <div class="d-flex flex-row justify-content-center">
        <div class="login-box">
          <h4 class="mb-3 text-center">{{ $t("loginPageTitle") }}</h4>
          <div class="card">
            <div class="card-body">
              <b-form class="mb-3" @submit.prevent="onSubmit">
                <div class="form-group">
                  <label for="input-username">{{ $t("usernameOrEmail") }}</label>
                  <div class="input-group mb-3">
                    <input id="input-username" type="text" class="form-control" v-model="username" required>
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <span class="fas fa-envelope"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="input-password">{{ $t("password") }}</label>
                  <div class="input-group mb-3">
                    <input id="input-password" :type="showPassword? 'text' : 'password'" class="form-control" v-model="password" required>
                    <div class="input-group-append">
                      <div class="input-group-text" @click="showPassword = !showPassword">
                        <span class="fas" :class="showPassword? 'fa-eye-slash' : 'fa-eye'"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="errorMsg" class="text-danger">{{ $t(errorMsg) }}</div>
<!--                <div class="d-flex flex-row align-items-center justify-content-between">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="remember" v-model="rememberMe">
                    <label class="custom-control-label" for="remember">{{ $t("stayLoggedIn") }}</label>
                  </div>
                  <div>
                    <button type="submit" class="btn btn-primary btn-block" :disabled="isLoading">{{ $t("login") }}</button>
                  </div>
                </div>-->
                <div>
                  <button type="submit" class="btn btn-primary btn-block" :disabled="isLoading">{{ $t("login") }}</button>
                </div>
                <div class="d-flex flex-row justify-content-between mt-2">
                  <router-link to="/forgot-password">{{ $t("forgotPasswordQMark") }}</router-link>
                  <router-link to="/signup">{{ $t("registerAccount") }}</router-link>
                </div>
                <div class="divider mt-3 mb-3">{{ $t("or") }}</div>
                <div class="text-center mb-3" v-if="enableSsoLogin">
                <b-button class="btn-block sso-login" variant="outline-dark" @click="onClickSsoLogin">
                  <img class="mr-1" src="images/logoVNPT2.png" alt="Logo" width="36px"/>   {{ $t("loginVnptSso") }}</b-button>
              </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </main>
</template>

<style lang="scss" scoped>
  .login-box {
    width: 400px;
  }
.divider {
  display: flex;
  align-items: center;
  color: #ced4da;
}

.divider::before, .divider::after {
  flex: 1;
  content: '';
  padding: 0.1px;
  background-color: #ced4da;
  margin: 5px;
}
.sso-login {
  border-color: #a5a5a5;
}
.sso-login:hover, .sso-login:active {
    border-color: #0066b4 !important;
    background: inherit !important;
    color: #0066b4 !important;
  
}
</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import BaseComponent from "@/components/BaseComponent";
  import * as userService from "@/service/userService";
  import environment from "@/environment";

  @Component
  export default class UserLogin extends BaseComponent {

    enableSsoLogin = window["vnptEConferencePortalEnableSsoLogin"] || true;

    username = "";
    password = "";
    rememberMe = false;
    errorMsg = null;

    showPassword = false;

    isLoading = false;

    mounted() {

    }


    onClickSsoLogin() {
      const service = location.origin + environment.appBaseUrl;
      localStorage.setItem("vnptSsoService", service);
      location.href = "https://id.vnpt.com.vn/cas/login?" + new URLSearchParams({ service }).toString();
    }


    async onSubmit() {

      try {
        this.errorMsg = null;
        this.isLoading = true;
        const user = await userService.signIn(this.username, this.password, this.rememberMe);

        if (user.mustChangePassword) {
          location.href = environment.appBaseUrl + "#/change-password";
        } else {
          location.href = environment.appBaseUrl;
        }

      } catch (e) {
        
        // this.errorMsg = e.response?.data?.code || e.code;

        const message = e.response?.data?.code || e.code;
        const parts = message.split('_');
        const partsLength = parts.length;
        if(partsLength > 1){
          this.errorMsg = this.$t(parts[0], { i: parts[1], m: parts[2] }).toString();
        }else{
          if(message == "LockAccountEnabled"){
            this.errorMsg = this.$t(message, { m: e.response?.data?.message }).toString();
          }else{
            this.errorMsg = message;
          }
        }
        
        console.error(e);

      } finally {
        this.isLoading = false;
      }
    }

  };
</script>


